import { EnvironmentProviders } from '@angular/core';
import { LogLevel, OpenIdConfiguration, provideAuth } from 'angular-auth-oidc-client';
import { createEgAssistantOidcConfig } from '@expertgroup/assistant';
import { environment } from '@/environments/environment';
import { PROTAX_CONFIG_ID } from './auth-config-ids';
import { assistantConfig } from './assistant.config';

/**
 * OIDC against the central ExpertGroup Identity issuer (Authorization Code + PKCE).
 * Mirrors ExpertGroup.Applications.Identity.UI:
 *  - refresh-token renewal (offline_access) — the issuer blocks iframe silent-renew.
 *  - autoUserInfo:false — identity & permissions come from the REST `/me` endpoint, never the token.
 *
 * ⚠️ `secureRoutes` is set but is NOT what attaches the bearer: this app uses its own `authInterceptor`,
 * which is why that interceptor — not this list — is where the two tokens are kept apart.
 */
const protaxConfig: OpenIdConfiguration = {
    configId: PROTAX_CONFIG_ID,
    authority: environment.issuer,
    clientId: environment.clientId,
    redirectUrl: environment.redirectUrl,
    postLogoutRedirectUri: environment.postLogoutRedirectUri,
    scope: environment.scope,
    responseType: 'code',
    useRefreshToken: true,
    silentRenew: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    autoUserInfo: false,
    ignoreNonceAfterRefresh: true,
    secureRoutes: [environment.apiUrl],
    logLevel: environment.production ? LogLevel.Error : LogLevel.Warn
};

/**
 * ⚠️ ProTax MORA ostati prvi u nizu. Njegov configId je zakucan na pozicioni string koji je biblioteka
 * ranije sama generisala, pa bi promena redosleda odjavila sve žive sesije.
 *
 * Asistentska konfiguracija se više ne piše ovde — dolazi iz `@expertgroup/assistant`, gde su njene nosive
 * odluke zakucane testovima. Ovaj fajl zna samo da je doda u niz kad postoji.
 */
const configs: OpenIdConfiguration[] = assistantConfig
    ? [protaxConfig, createEgAssistantOidcConfig(assistantConfig)]
    : [protaxConfig];

export const authConfig: EnvironmentProviders = provideAuth({ config: configs });
